export const useNotifications = () => {
  // @TODO: Create test for this
  const { $api } = useNuxtApp()
  const { loggedIn } = storeToRefs(useAuthStore())
  const userStore = useUserStore()
  const notifications = useState('notifications', () => ref(null))
  const pagination = useState('pagination', () => ref(null))

  const fetchNotification = async (id: String) => {
    if (!loggedIn.value || !userStore.id) { return }
    const data = await $api(
      `customers/${userStore.id}/notifications/${id}`
    )
    return data
  }

  const restore = async (id: String) => {
    if (!loggedIn.value || !userStore.id) { return }
    await $api(
      `customers/${userStore.id}/notifications/${id}/restore`,
      { method: 'POST' }
    )
  }

  const archive = async (id: String) => {
    if (!loggedIn.value || !userStore.id) { return }
    await $api(
      `customers/${userStore.id}/notifications/${id}`,
      { method: 'DELETE' }
    )
  }

  const massFetch = async (activeType?: String) => {
    if (!loggedIn.value || !userStore.id || !activeType) { return }
    let url = `customers/${userStore.id}/notifications`
    if (activeType === 'archive') {
      url += '/archive'
    }
    const data:any = await $api(url)
    if (data) {
      notifications.value = data.notifications
      pagination.value = data.pagination
    }

    return data
  }

  const massRestore = async (selectedNotifications:[String]) => {
    if (!loggedIn.value || !userStore.id) { return }
    await $api(
      `customers/${userStore.id}/notifications/restore/batch`,
      {
        method: 'POST',
        body: { notificationIds: [...selectedNotifications] }
      }
    )
  }

  const massArchive = async (selectedNotifications:[String]) => {
    if (!loggedIn.value || !userStore.id) { return }
    await $api(
      `customers/${userStore.id}/notifications/batch`,
      {
        method: 'DELETE',
        body: { notificationIds: [...selectedNotifications] }
      }
    )
  }

  return {
    notifications,
    pagination,
    fetchNotification,
    restore,
    archive,
    massFetch,
    massRestore,
    massArchive
  }
}
